export default {"src":"/_next/static/media/SVGServices01.7c796f3e.svg","height":679,"width":796};